/**
 * TanStack Query hooks for `campaign-device-targeting`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignDeviceTargetingQueryKeys,
	type CreateCampaignDeviceTargetingBody,
	type ListCampaignDeviceTargetingResponse,
	type CampaignDeviceTargetingRow,
} from "./api";

export function useCampaignDeviceTargetingList(): UseQueryResult<ListCampaignDeviceTargetingResponse, Error> {
	return useQuery({
		queryKey: campaignDeviceTargetingQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignDeviceTargetingCreate(): UseMutationResult<CampaignDeviceTargetingRow, Error, CreateCampaignDeviceTargetingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignDeviceTargetingQueryKeys.all });
		},
	});
}

export function useCampaignDeviceTargetingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignDeviceTargetingQueryKeys.all });
		},
	});
}
